/**
 * Буфер на телефоне: ClipboardItem с отложенным текстом, затем writeText,
 * затем execCommand. Жест сгорает — цепочка должна стартовать синхронно.
 */

export async function copyPhone(text: string): Promise<boolean> {
  const itemOk = await copyItem(text);
  if (itemOk) return true;
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* iOS Safari часто режет writeText после ухода фокуса */
  }
  return copyExec(text);
}

function copyItem(text: string): Promise<boolean> {
  const clip = navigator.clipboard;
  const CI = typeof ClipboardItem === 'function' ? ClipboardItem : null;
  if (!clip || typeof clip.write !== 'function' || CI === null) return Promise.resolve(false);
  try {
    const blob = Promise.resolve(new Blob([text], { type: 'text/plain' }));
    const item = new CI({ 'text/plain': blob });
    return clip.write([item]).then(() => true).catch(() => false);
  } catch {
    return Promise.resolve(false);
  }
}

export function copyExec(text: string): boolean {
  const exec = document.execCommand?.bind(document);
  if (exec === undefined) return false;
  try {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.setAttribute('aria-hidden', 'true');
    area.style.position = 'fixed';
    area.style.left = '-9999px';
    area.style.top = '0';
    document.body.append(area);
    area.focus();
    area.select();
    const ok = exec('copy');
    area.remove();
    return ok;
  } catch {
    return false;
  }
}

/** Синхронный старт: exec сразу, ClipboardItem параллельно. */
export function copyPhoneStart(text: string): Promise<boolean> {
  const fallback = copyExec(text);
  return copyPhone(text).then((ok) => ok || fallback);
}
